import { SVGProps, memo } from "react";

const InviteFriendsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={props.width || "24"} height={props.height || "24"} fill={props.color || "none"} version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g id="add guy" transform="translate(-10.419 -7.631)">
        <g id="Vector" clipRule="evenodd" fill={props.color || "#424242"} fillRule="evenodd" stroke="none">
          <path d="m20.494 18.546c1.5593-1.5013 1.5593-3.9352 0-5.4365-1.5593-1.5012-4.0873-1.5012-5.6466 0-1.5592 1.5013-1.5592 3.9352 0 5.4365 1.5593 1.5012 4.0873 1.5012 5.6466 0zm1.3192 1.2701c2.2878-2.2027 2.2878-5.774 0-7.9767-2.2878-2.2027-5.9971-2.2027-8.2849 0-2.2879 2.2027-2.2879 5.774 0 7.9767 2.2878 2.2027 5.9971 2.2027 8.2849 0z"/>
          <path d="m17.488 24.243c-2.3457 0-4.2379 1.6693-4.5945 3.884-0.0825 0.5123-0.4884 0.9473-1.0073 0.9473-0.4918 0-0.9027-0.3909-0.8566-0.8805 0.3074-3.2627 3.0062-5.7807 6.389-5.7807 3.3607 0 6.2349 2.4852 6.8164 5.7168 0.0919 0.5108-0.3292 0.9444-0.8481 0.9444-0.4918 0-0.8868-0.3926-0.9927-0.8729-0.4965-2.2516-2.5343-3.9584-4.9062-3.9584z"/>
        </g>
        <path d="m29.5 17v3.5m0 3.5v-3.5m0 0h3.5m-3.5 0h-3.5" stroke={props.color || "#424242"} strokeLinecap="round" strokeWidth={props.strokeWidth || "1.6"}/>
      </g>
    </svg>
  );
};

export default memo(InviteFriendsIcon);
